import React from 'react';
import { Option } from '../interfaces';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import SettingsIcon from '@mui/icons-material/Settings';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';

export const myProfileMenuOptions: Option[] = [
  {
    key: 'profileData',
    link: '/profile',
    icon: <PersonIcon />,
    inProduction: true,
  },
  {
    key: 'notifications',
    link: '/profile/notifications',
    icon: <NotificationsIcon />,
    inProduction: true,
  },
  {
    key: 'scoreData',
    link: '/profile/scores',
    icon: <ScoreboardIcon />,
  },
  {
    key: 'trainingData',
    link: '/profile/training',
    icon: <MilitaryTechIcon />,
  },
  {
    key: 'profileSettings',
    link: '/profile/settings',
    icon: <SettingsIcon />,
  },
];
